import React from "react";

const AdminHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">1. Login</a>
            <a href="#university-management">2. University Management</a>
            <a href="#department">3. Department</a>
            <a href="#configuration">4. Configuration</a>
            <a href="#visibility-priority">5. Visibility & Priority Settings</a>
            <a href="#feedback">6. Feedback</a>
            <a href="#settings">7. Settings</a>
            <a href="#freshman-configuration">8. Freshman Configuration</a>
            <a href="#ai-configuration">9. AI Configuration</a>
            <a href="#navbar">10. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>1. Login</h2>
              <p>
                The login page allows Super Admin users to securely sign in.
                Follow these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="university-management" className="section">
              <h2>2.University Management</h2>
              <p>
                This section allows users to add and manage colleges under a
                university. Users can create new colleges, and existing colleges
                can be viewed, edited, or deactivated from the index page.
              </p>
              <h3>2.1 College List Page (Index)</h3>
              <p>
                The Index Page lists all previously created colleges and a “ Add
                New” button for creating new college/University administration.
                Each college entry includes the following action buttons:
              </p>
              <ul>
                <li>View – To view full details of the college.</li>
                <li>Edit – To update the college’s information.</li>
                <li>
                  Delete – To inactivate the college from the list (not
                  permanent deletion).
                </li>
              </ul>
              <img
                src="assets/images/help/college_list.png"
                alt="College Index"
              />
              <h3>2. 2 Add a New College</h3>
              <ol>
                <li>Navigate to the University Management Page.</li>
                <li>
                  Click on the “Add New” Button. A popup window will appear
                  titled “Add New University Management”.
                </li>
                <li>
                  University Name: The university name is auto populated and
                  cannot be edited.
                </li>
                <li>
                  Management Type: Choose either College Administration or
                  University Administration from the dropdown.
                </li>
                <li>
                  University Management Name: Based on the selected Management
                  Type, relevant college/university names will be shown in the
                  dropdown for selection.
                </li>
                <li>Address: Fill address of the college.</li>
                <li>
                  Location: Enter the location or city where the college is
                  located.
                </li>
                <li>Logo : Click Choose File to upload a logo.</li>
                <li>
                  Login User ID: Choose the college admin (Login User ID)
                  assigned to this college from the dropdown list.
                </li>
                <li>
                  Description: Provide a brief description of the college.
                </li>
                <li>
                  Save : Clicking Save creates the college and lists it on the
                  index page.
                </li>
              </ol>
              <img
                src="assets/images/help/add_college.png"
                alt="Add Colleges"
              />
              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Add College</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Edit College Detail</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Deactivate</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="department" className="section">
              <h2>3. Department</h2>
              <p>
                The Department Management section allows users to create, view,
                edit, and manage departments under a selected college or
                university administration.
              </p>
              <h3>3.1 Department List Page(Index)</h3>
              <p>
                The Index Page lists all previously created departments and a
                "Add New" button for creating new department. Each department
                includes the following action buttons:
              </p>
              <ul>
                <li>View – To view full details of the department.</li>
                <li>Edit – To update the department's information.</li>
                <li>
                  Delete – To inactivate the department from the list (not
                  permanent deletion).
                </li>
                <img
                  src="assets/images/help/department_list.png"
                  alt="Department Index"
                />
              </ul>
              <h3>3. 2 Add a New Department</h3>
              <ol>
                <li>Navigate to the Department Page.</li>
                <li>
                  {" "}
                  Click on the “Add New” Button. A popup titled "Add New
                  Department" will appear.
                </li>
                <li>
                  University Management: Choose the College Name or
                  Administration Name from the dropdown.
                </li>
                <li>
                  {" "}
                  Department Name: Based on the selected college/administration,
                  related Department Names will be populated in the dropdown.
                </li>
                <li>Address : Fill in the department’s address.</li>
                <li>Enter Location: Enter the department location</li>
                <li>
                  Phone Number: Enter the contact number for the department.
                </li>
                <li>
                  Department Logo : Click Choose File to upload the department
                  logo.
                </li>
                <li>
                  Description: Enter a brief description of the department.
                </li>
                <li>
                  Login User ID : Select the department admin from the Login
                  User ID dropdown. This list is retrieved from an external API.
                </li>
                <li>
                  Save : Click Save creates the department and lists it on the
                  index page.
                </li>
                <img src="assets/images/help/add_department.png" alt="Login" />
              </ol>
              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Add Department</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Edit Department Detail</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Deactivate</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="configuration" className="section">
              <h2>4. Configuration</h2>
              <h3>4.1 Button</h3>
              <h3>4.1.1 Button List Page(Index)</h3>
              <p>
                The Index Page lists all previously created buttons. Each button
                entry includes the following action buttons
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the button’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the button
                  from the list (not permanent deletion).
                </li>
                <li>Filter – User Type</li>
                <img
                  src="assets/images/help/button_list.png"
                  alt="Button Index"
                />
              </ul>
              <h3>4. 1.2 Add a New Button</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Button.</li>
                <li>
                  {" "}
                  Click on the “Add New” Button. A popup titled "Add New Button"
                  will appear.
                </li>
                <li>User type: Select user type staff/faculty/student</li>
                <li> Name: Enter button name</li>
                <li>
                  URL: Enter the link to which the user should be redirected.
                </li>
                <li>
                  Page block: Configured pages of corresponding users are
                  listed.
                </li>
                <li>College: Select colleges from the dropdown</li>
                <li>
                  Click on the “Save” Button: The new button will be created and
                  listed on the index page.
                </li>
                <img src="assets/images/help/add_button.png" alt="Login" />
              </ol>

              <h3>4.2 Widget</h3>
              <h3>4.2.1 Widget List Page(Index)</h3>
              <p>
                The Index Page lists shows all previously created widgets. Each
                widgets entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the widget’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the widgets
                  from the list (not permanent deletion).
                </li>
                <li>Filter – User Type</li>
                <img
                  src="assets/images/help/widget_list.png"
                  alt="Widget Index"
                />
              </ul>

              <h3>4.2.2 Add a New Widget</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Widget</li>
                <li>
                  {" "}
                  Click on the “Add New” Widgets. A popup titled "Add New
                  Widget" will appear.
                </li>
                <li>User type: Select user type staff/faculty/student</li>
                <li> Name: Enter widgets name</li>
                <li>Icon : Click Choose File to upload</li>
                <li>Description: Add widget description</li>
                <li>
                  URL: Enter the link to which the user should be redirected.
                </li>
                <li>
                  Page block: Configured pages of corresponding users are
                  listed.
                </li>
                <li>College: Select colleges from the dropdown</li>
                <li>
                  Click on the “Save” Button: The new widget will be created and
                  listed on the index page.
                </li>
                <img src="assets/images/help/add_widget.png" alt="Login" />
              </ol>

              <h3>4.3 Apps</h3>
              <h3>4.3.1 Apps List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Apps. Each Apps
                entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the app’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the apps from
                  the list (not permanent deletion).
                </li>
                <li>Filter – User Type</li>
                <img src="assets/images/help/app_list.png" alt="Button Index" />
              </ul>
              <h3>4.3.2 Add a New App</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Apps</li>
                <li>
                  {" "}
                  Click on the “Add New” Apps. A popup titled "Add New App" will
                  appear.
                </li>
                <li>User type: Select user type staff/faculty/student</li>
                <li> Name: Enter apps name</li>
                <li>Icon : Add logo using choose file option</li>
                <li>Description: Add app description</li>
                <li>
                  URL: Enter the link to which the user should be redirected.
                </li>
                <li>
                  Page block: Configured pages of corresponding users are
                  listed.
                </li>
                <li>College: Configured colleges are listed</li>
                <li>
                  Click on the “Save” Button: The new app will be created and
                  listed on the index page.
                </li>
                <img src="assets/images/help/add_app.png" alt="Add Apps" />
              </ol>

              <h3>4.4 Notifications</h3>
              <h3>4.4.1 Notifications List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Notifications. Each
                Notifications entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the notification’s
                  information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the
                  notification from the list (not permanent deletion).
                </li>
                <li>Filter – User Type</li>
                <img
                  src="assets/images/help/notification_list.png"
                  alt="Notification Index"
                />
              </ul>
              <h3>4. 4.2 Add a New Notification</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Notifications</li>
                <li>
                  Click on the “Add New” Notification. A popup titled "Add New
                  Notification" will appear.
                </li>
                <li>Notification type: Select notification type</li>
                <li>User type: Select user type Staff/Faculty/Student</li>
                <li>
                  If the user type is selected as Student, an option will appear
                  to mark whether the notification is visible to Freshman
                  (Yes/No).
                </li>
                <li> Title: Add notification title</li>
                <li>Image:Add image using choose file option</li>
                <li>Notification message: Add notification message</li>
                <li>
                  Start date and end date: Select the date. Based on these
                  dates, the notification will be visible to users.
                </li>
                <li>
                  Department colleges: Corresponding colleges and its
                  departments are listed
                </li>
                <li>
                  Page block: Configured pages of corresponding users are
                  listed.
                </li>
                <li>College: Configured colleges are listed</li>
                <li>
                  Click on the “Save” Button: The new notification will be
                  created and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_notification.png"
                  alt="Add Notification"
                />
              </ol>

              <h3>4.5 Technology Resources</h3>
              <h3>4.5.1 Technology Resources List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Technology
                Resources. Each Technology Resources entry includes the
                following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Technology
                  Resources’s information.
                </li>
                <li>
                  Deactivate – Click the delete icon to inactivate the
                  Technology Resources from the list (not permanent deletion).
                </li>
                <img
                  src="assets/images/help/techResource_list.png"
                  alt="TechnologyResources Index"
                />
              </ul>
              <h3>4. 5.2 Add a New Technology Resources</h3>
              <ol>
                <li>
                  Navigate to the Configuration Page &gt; Technology Resources
                </li>
                <li>
                  {" "}
                  Click on the “Add New” Technology Resource. A popup titled
                  "Add New Technology Resource" will appear.
                </li>
                <li>
                  User type: The user type is staff which is already preselected
                </li>
                <li>Name: Add resource name</li>
                <li>Icon: Add logo using choose file option</li>
                <li>
                  URL: Enter the link to which the user should be redirected.{" "}
                </li>
                <li>
                  Page block: Configured pages of corresponding users are
                  listed.
                </li>
                <li>College: Configured colleges are listed</li>
                <li>
                  Department colleges: Corresponding colleges and its
                  departments are listed
                </li>
                <li>
                  Click on the “Save” Button: The new Technology Resource will
                  be created and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_techResource.png"
                  alt="Add TechnologyResource"
                />
              </ol>

              <h3>4.6 Email configuration </h3>
              <h3>4.6.1 Email configurations List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Email
                configurations. Each Email configurations entry includes the
                following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Email configuration’s
                  information.
                </li>
                <li>Filter – University Management</li>
                <img
                  src="assets/images/help/emailConfig_list.png"
                  alt="EmailConfigurations Index"
                />
              </ul>
              <h3>4. 6.2 Add a New Email Configuration</h3>
              <ol>
                <li>
                  Navigate to the Configuration Page &gt; Email configurations
                </li>
                <li>
                  {" "}
                  Click on the “Add New” Email configuration. A popup titled
                  "Add New Email configuration" will appear.
                </li>
                <li>College: Select colleges from dropdown</li>
                <li>Select block: Select block field data</li>
                <li>
                  User type: : Select the user type
                  staff/faculty/student/freshman/college admin/department admin
                </li>
                <li>Add recipient email id</li>
                <li>
                  Click on the “Save” Button: The new Email configuration will
                  be created and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_emailConfig.png"
                  alt="Add EmailConfiguration"
                />
              </ol>

              <h3>4.7 Description </h3>
              <h3>4.7.1 Description List Page(Index)</h3>
              <p>
                The Index Page lists all previously created Descriptions. Each
                Descriptions entry includes the following actions
              </p>
              <ul>
                <li>
                  Edit – Click the edit icon to update the Description’s
                  information.
                </li>
                <li>Filter – User Type</li>
                <img
                  src="assets/images/help/description_list.png"
                  alt="Descriptions Index"
                />
              </ul>
              <h3>4. 7.2 Add a New Description</h3>
              <ol>
                <li>Navigate to the Configuration Page &gt; Descriptions</li>
                <li>
                  {" "}
                  Click on the “Add New” Description. A popup titled "Add New
                  Description" will appear.
                </li>
                <li>College: Select colleges from dropdown</li>
                <li>
                  Select page block: Configured pages of corresponding users are
                  listed
                </li>
                <li>
                  User type: : Select the user type
                  Staff/Faculty/Student/Freshman/University Management
                  Admin/Department admin
                </li>
                <li>Add title</li>
                <li>Add description</li>
                <li>Visibility Toggle" (Show/Hide) the description</li>
                <li>
                  Click on the “Save” Button: The new Description will be
                  created and listed on the index page.
                </li>
                <img
                  src="assets/images/help/add_description.png"
                  alt="Add Description"
                />
              </ol>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Button</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Widget</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>App</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Notification</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Technology Resources</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Email Configuration</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Training</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Report</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Department Resources</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Training Help</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="visibility-priority" className="section">
              <h2>5. Visibility & Priority Settings</h2>
              <p>
                Users have the ability to set the visibility and priority of
                configured dashboard items based on different personas: Staff,
                Student, and Faculty.
              </p>
              <h3>5.1 Staff</h3>
              <ul>
                <li>Navigate to “ Staff”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
              </ul>
              <h3>5.2 Student</h3>
              <ul>
                <li>Navigate to “ Student”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
              </ul>
              <h3>5.3 Faculty</h3>
              <ul>
                <li>Navigate to “ Faculty”</li>
                <li>
                  Change Visibility: Uncheck the radio button to hide any item.
                </li>
                <li>
                  Change Order: Drag and drop items to rearrange the display
                  order
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Staff Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
                <tr>
                  <td>Faculty Visibility and Priority settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Student visibility and Priority Settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="feedback" className="section">
              <h2>6. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>6.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img
                  src="assets/images/help/superadmin_feedback.png"
                  alt="Feedback"
                />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>6.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Feedback</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Rate Us</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
              </table>
            </div>

            <div id="settings" className="section">
              <h2>7. Settings</h2>
              <h3>7.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
              <h3>7.2 Visibility & Priority Settings of Apps and Widgets</h3>
              <p>
                This section allows users to customize the visibility and
                display order of apps and widgets in their portal.
              </p>
              <ul>
                <li>
                  In the Settings Page, all apps and widgets are listed along
                  with their current visibility and order.
                </li>
                <li>
                  Change Visibility: To hide an app or widget, uncheck the radio
                  button next to its name.
                </li>
                <li>
                  Change Display Order: Rearrange the apps and widgets by
                  dragging and dropping them into the desired order.
                </li>
              </ul>

              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Edit Profile</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
                <tr>
                  <td>Visibility & Priority Settings</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                  <td>&#10004;</td>
                </tr>
              </table>
            </div>

            <div id="freshman-configuration" className="section">
              <h2>8. Freshman Configuration</h2>
              <h3>8.1 Configuration</h3>
              <p>
                The Freshman Configuration section allows admin to define and
                manage the step-by-step registration process for freshman
                students. It will be displayed on the freshman registration
                dashboard based on the configured steps for each student type
                and program level.
              </p>
              <h3>8.1.1 Index Page</h3>
              <ul>
                <li>
                  Displays a list of all existing freshman configurations.
                </li>
                <li>
                  Provides action icons for each configuration:
                  <ul>
                    <li>View – View configuration details.</li>
                    <li>Edit – Modify the configuration.</li>
                    <li>Delete – Deactivate the configuration.</li>
                  </ul>
                </li>
                <li>
                  Add Configuration button is available to create a new freshman
                  registration setup.
                </li>
                <img
                  src="assets/images/help/freshmanConfig_list.png"
                  alt="Freshman Configuration"
                />
              </ul>

              <h2>8.1.2 Add Configuration</h2>
              <ul>
                <li>
                  Click on “Add Configuration” button a popup titled “Add
                  Freshman Process” will appear.
                </li>
                <li>
                  Select Program Level: DIEP ESL / Graduate / Undergraduate
                </li>
                <li>
                  Select Yes or No to indicate international student status.
                </li>
                <li>Select College from the drop-down.</li>
                <li>
                  Enter the email ID where approval notifications will be sent
                  when tasks are completed.
                </li>
                <li>
                  Select Main Tasks :
                  <ul>
                    <li>
                      Select main tasks from the dropdown list set in Main Task
                      Configuration.
                    </li>
                    <li>
                      For each task, you can:
                      <ul>
                        <li>
                          Select a Predecessor Step (tasks listed above the
                          current one).
                        </li>
                        <li>Drag to change the step order.</li>
                        <li>
                          Remove any step by clicking the X icon if a step is
                          not required.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  Select Sub Task
                  <ul>
                    <li>
                      To configure sub tasks, click on the main task. Then
                      choose sub tasks from the dropdown list set in Sub Task
                      Configuration
                    </li>
                    <li>
                      For each task, you can:
                      <ul>
                        <li>
                          Select a Predecessor Step (tasks listed above the
                          current one).
                        </li>
                        <li>
                          Each step shows a configured URL, which can be edited
                          if required.
                        </li>
                        <li>Drag to change the step order.</li>
                        <li>
                          Remove any step by clicking the X icon if it is not
                          required.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  Click Save to save the configuration and add it to the index.
                </li>
                <li>Click Close to exit the popup without saving.</li>
              </ul>
              <img
                src="assets/images/help/add_freshmanConfig.png"
                alt="Add Freshman Configuration"
              />
              <p>
                Note: When a configuration is updated, the version number
                changes. Students who already started registration will continue
                with the old version, and new students will use the updated one
              </p>

              <h3>8.2 Main Task </h3>
              <p>
                The Main Task Configuration section allows administrators to
                create and manage the main tasks used in the freshman
                registration process.
              </p>
              <h3>8.2.1 Index Page</h3>
              <ul>
                <li>Displays a list of all existing main tasks.</li>
                <li>
                  Action icons available:
                  <ul>
                    <li>Edit – Modify an existing main task.</li>
                    <li>Delete – Deactivate a main task</li>
                  </ul>
                </li>
                <li>Add New button is available to create a new main task.</li>
                <img
                  src="assets/images/help/mainTask_list.png"
                  alt="MainTask Index"
                />
              </ul>

              <h3>8.2.2 Add Main Task</h3>
              <ul>
                <li>
                  Click on “Add New” button, a popup titled “Add Main Task” will
                  appear.
                </li>
                <img
                  src="assets/images/help/add_mainTask.png"
                  alt="Add MainTask"
                />
                <li>Name: Enter the name of the task.</li>
                <li>Description: Enter brief description about Task</li>
                <li>
                  Click Save to create the main task and display it in the index
                  list.
                </li>
                <li>Click Close to exit the popup without saving.</li>
              </ul>

              <h3>8.3 Sub Task</h3>
              <p>
                The Main Task Configuration section allows administrators to
                create and manage the sub tasks used in the freshman
                registration process.
              </p>
              <h3>8.3.1 Index Page</h3>
              <ul>
                <li>Displays a list of all existing sub tasks.</li>
                <li>
                  Action icons available:
                  <ul>
                    <li>Edit – Modify an existing main task.</li>
                    <li>Delete – Deactivate a main task</li>
                  </ul>
                </li>
                <li>“Add New” button is available to create a new sub task.</li>
              </ul>
              <img
                src="assets/images/help/subTask_list.png"
                alt="SubTask Index"
              />

              <h3>8.3.2 Add Sub Task </h3>
              <ul>
                <li>
                  Click on “Add New” button, a popup titled “Add sub Task” will
                  appear.{" "}
                </li>
                <img
                  src="assets/images/help/add_subTask.png"
                  alt="Add SubTask"
                />
                <li>Name: Enter the name of the task.</li>
                <li>
                  URL: Provide the URL that the user should be redirected to
                  when they click on the task.
                </li>
                <li>
                  Mode of Progress Update: Select the method using radio
                  buttons:
                  <ul>
                    <li>
                      API – Task progress is updated automatically via API
                      response.
                    </li>
                    <li>
                      Manual – Freshman manually updates task progress by
                      entering a percentage.
                    </li>
                  </ul>
                </li>
                <li>Description: Enter brief description about Task</li>
                <li>
                  Click Save to create the main task and display it in the index
                  list.
                </li>
                <li>Click Close to exit the popup without saving.</li>
              </ul>
              <table className="feature-table">
                <tr>
                  <th>Feature</th>
                  <th>Super Admin</th>
                  <th>College Admin</th>
                  <th>Department Admin</th>
                  <th>Staff</th>
                  <th>Student/Freshman</th>
                  <th>Faculty</th>
                </tr>
                <tr>
                  <td>Freshman Configuration </td>
                  <td>&#10004;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                  <td>&#10008;</td>
                </tr>
              </table>
            </div>

            <div id="ai-configuration" className="section">
              <h2>9. AI Configuration</h2>
              <p>
                The admin configuration page will enable the super admin to
                configure the master agent API key to connect the agents to the
                BUDU portal. The Super Admin can configure up to three agents
                for each college, with one agent assigned to each user type.
                Once the master agent’s API key is added, the corresponding
                agent is activated for that specific user type.
              </p>
              <h3>9.1. AI Configuration Index </h3>
              <ul>
                <li>Displays a list of all existing AI agent configuration</li>
                <li>
                  Action icons available
                  <ul>
                    <li>Edit – Modify an existing AI agent configuration.</li>
                    <li>Delete – Delete an AI agent configuration</li>
                  </ul>
                </li>
                <li>“Add New” button is available to setup new agent </li>
                <li>Filter: University Management </li>
                <img
                  src="assets/images/help/aiConfig_list.png"
                  alt="AI Configuration List"
                />
              </ul>
              <h3>9.2. Add New</h3>
              <ol>
                <li>
                  Click on “Add New” button, a popup titled “Add New AI
                  Configuration” will appear.
                </li>
                <li>University Management: Select the college name.</li>
                <li>
                  User Type: Choose the user type (Student, Staff, Faculty).
                </li>
                <li>
                  API Key: Enter the master agent’s API key generated from
                  Copilot.
                </li>
                <li>
                  Name: Provide a display name that will appear in the index.
                </li>
                <li>Click Save and it will display it in the index list.</li>
                <li>Click Close to exit the popup without saving.</li>
              </ol>
              <img
                src="assets/images/help/add_aiConfig.png"
                alt="Add AI Configuration"
              />
            </div>

            <div id="navbar" className="section">
              <h2>10. Navigation Bar</h2>
              <ul>
                <li>
                  Email: Clicking on the Email Icon will redirect to the Outlook
                  Mail Inbox.
                </li>
                <li>
                  Profile Icon: Once the Logout button is clicked, you will be
                  logged out and redirected to the login page.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHelpInstructions;
